import React from 'react';
import PropTypes from 'prop-types';

export default class NumericalAvailabilityFilter extends React.Component {
  constructor(props) {
    super(props);
    this.onInputChange = this.onInputChange.bind(this);
  }

  onInputChange(newValue) {
    if (newValue === '') {
      this.props.onChange({ value: '' });
      return;
    }

    let value = parseInt(newValue, 10);

    if (isNaN(value)) {
      return;
    }

    if (value > this.props.maxValue) {
      value = this.props.maxValue;
    } else if (value < this.props.minValue) {
      value = this.props.minValue;
    }

    this.props.onChange({ value });
  }

  render() {
    let classOuter = 'rec-grid-5-12';
    let classWrap = '';
    let classItem = '';

    if (this.props.fullWidth) {
      classOuter = 'full';
    }

    if (this.props.inline) {
      classWrap = 'rec-form-inline-item-wrap';
      classItem = 'rec-form-inline-item';
      classOuter = '';
    }

    if (this.props.flexItem) {
      classOuter = 'flexItem';
      classWrap = '';
      classItem = 'flex';
    }

    const { value } = this.props;
    const inputValue = !value && value !== 0 ? '' : value;

    return (
      <div className={classOuter}>
        <div className={classWrap}>
          <div className={classItem}>
            <label htmlFor={`number-input-${this.props.id}`}>
              {`${this.props.label} (${this.props.maxValue} max)`}
            </label>
            <input
              type="number"
              id={`number-input-${this.props.id}`}
              disabled={this.props.disabled}
              value={inputValue}
              min={this.props.minValue}
              max={this.props.maxValue}
              step="1"
              onChange={(e) => this.onInputChange(e.target.value)} />
          </div>
        </div>
      </div>
    );
  }
}

NumericalAvailabilityFilter.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  minValue: PropTypes.number,
  maxValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  flexItem: PropTypes.bool,
  fullWidth: PropTypes.bool,
  id: PropTypes.string
};

NumericalAvailabilityFilter.defaultProps = {
  value: '',
  onChange: () => { },
  inline: false,
  flexItem: false,
  label: "",
  minValue: 0,
  maxValue: 0,
  fullWidth: false,
  id: ''
};